/* Only legacy aliases redirect. Native Shopify policies render directly. */
(() => {
  const aliases = {
    '/policies/shipping': '/policies/shipping-policy',
    '/pages/shipping': '/policies/shipping-policy',
    '/policies/returns': '/policies/refund-policy',
    '/policies/return-policy': '/policies/refund-policy',
    '/policies/returns-policy': '/policies/refund-policy',
    '/pages/returns': '/policies/refund-policy',
    '/policies/damages': '/policies/refund-policy#damages',
    '/policies/damages-policy': '/policies/refund-policy#damages',
    '/pages/damages': '/policies/refund-policy#damages',
    '/policies/contact': '/pages/customer-care#contact',
    '/pages/contact': '/pages/customer-care#contact',
    '/pages/contact-us': '/pages/customer-care#contact'
  };
  const target = aliases[location.pathname.replace(/\/$/, '')];
  if (target) location.replace(target);
})();
